export const maritalStatusOptions = [
  { label: 'Single (Never Married)', value: 'Single (Never Married)' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widowed', value: 'Widowed' },
  { label: 'Separated', value: 'Separated' },
  { label: 'Anyone', value: 'Anyone' },
];

export const brideGroomCategoryOptions = [
  { label: 'Domestic-India', value: 'Domestic-India' },
  { label: 'International', value: 'International' },
  { label: 'Vaidika', value: 'Vaidika' },
  { label: 'Anyone', value: 'Anyone' },
];

export const subCasteOptions = [
  { label: "Madhva (Ã Â²Â®Ã Â²Â¾Ã Â²Â§Ã Â³ÂÃ Â²Âµ)", value: "Madhva (Ã Â²Â®Ã Â²Â¾Ã Â²Â§Ã Â³ÂÃ Â²Âµ)" },
  { label: "Smarta (Ã Â²Â¸Ã Â³ÂÃ Â²Â®Ã Â²Â¾Ã Â²Â°Ã Â³ÂÃ Â²Â¤)", value: "Smarta (Ã Â²Â¸Ã Â³ÂÃ Â²Â®Ã Â²Â¾Ã Â²Â°Ã Â³ÂÃ Â²Â¤)" },
  { label: "Srivaishnava (Ã Â²Â¶Ã Â³ÂÃ Â²Â°Ã Â³â‚¬Ã Â²ÂµÃ Â³Ë†Ã Â²Â·Ã Â³ÂÃ Â²Â£Ã Â²Âµ)", value: "Srivaishnava (Ã Â²Â¶Ã Â³ÂÃ Â²Â°Ã Â³â‚¬Ã Â²ÂµÃ Â³Ë†Ã Â²Â·Ã Â³ÂÃ Â²Â£Ã Â²Âµ)" },
  { label: "Others (Ã Â²â€¡Ã Â²Â¤Ã Â²Â°Ã Â²Â°Ã Â³Â)", value: "Others (Ã Â²â€¡Ã Â²Â¤Ã Â²Â°Ã Â²Â°Ã Â³Â)" },
];

export const hobbyOptions = [
  { label: 'Reading', value: 'Reading' },
  { label: 'Traveling', value: 'Traveling' },
  { label: 'Music', value: 'Music' },
  { label: 'Sports', value: 'Sports' },
  { label: 'Art & Craft', value: 'Art & Craft' },
  { label: 'Cooking', value: 'Cooking' },
  { label: 'Meditation', value: 'Meditation' },
  { label: 'Gardening', value: 'Gardening' },
  { label: 'Photography', value: 'Photography' },
];

export const dietOptions = [
  { label: 'Vegetarian', value: 'Vegetarian' },
  { label: 'Eggetarian', value: 'Eggetarian' },
  { label: 'Non-Vegetarian', value: 'Non-Vegetarian' },
  { label: 'Vegan', value: 'Vegan' },
  { label: "Doesn't Matter", value: "Doesn't Matter" },
];
